module.exports = __webpack_public_path__ + "static/img/character2.3649ba0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/character2.svg
// module id = gyjj
// module chunks = 12